import React, { useEffect } from 'react';

const AdUnitComponent = ({ data, containerId}) => {    

  useEffect(() => {

    const displayAd = () => {
      window.googletag.display(containerId);
      //window.googletag.pubads().refresh();
    };

    setTimeout(displayAd, 200);    
  }, [containerId]);

  return <div id={containerId} style={data.styles}></div>;
};

export default AdUnitComponent;